import { render } from "./BlogComments.vue?vue&type=template&id=6bcf1c24"
import script from "./BlogComments.vue?vue&type=script&lang=js"
export * from "./BlogComments.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__